import r from "../managers/braze-instance.js";
export function isInitialized() {
  return r.nt();
}
